export default __webpack_public_path__ + "static/media/ChevyFavicon.9adfca67.ico";